import { Injectable } from '@angular/core'
import { Apollo } from 'apollo-angular'
import { Observable } from 'rxjs'
import { ApolloQueryResult } from 'apollo-client'
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

interface Data {
  features: Feature[];
}

export type Feature = 'writer_signup_suspended'; // or whatever it's called

export const AppFeaturesQuery: DocumentNode = gql`
  query AppFeaturesQuery {
    features
  }
`

@Injectable({
  providedIn: 'root'
})
export class FeatureQueries {
  constructor(private apollo: Apollo) {}

  getAppFeatures(): Observable<ApolloQueryResult<Data>> {
    return this.apollo.watchQuery<Data>({
      query: AppFeaturesQuery,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network'
    }).valueChanges
  }
}
